<template>
    <div class="modalV2">
        <div class="card">
            <div class="row-card-title">
                <span class="card-title">{{ screen_data.card_title }}</span>
                <button
                    v-if="screen_data.view != 'waiting_screen'"
                    @click="screen_data.view === 'final_result_screen' ? handleFinish() : show_contract_modal = false"
                >
                    <AppIcon :src="require('@/assets/close_small.svg')" :size="10" :color-map="{ '351457': 'primaryDark' }"/>
                </button>
            </div>
            <div class="card-body" v-if="screen_data.view == 'select_plan' || screen_data.view == 'select_payment_method'">
                <div class="card-body-left" v-if="screen_data.view == 'select_plan'">
                    <div v-if="screen_data.is_services_loading" style="display: flex; justify-content: center; align-items: center; height: 100%;">
                        <v-progress-circular
                            indeterminate
                            color="var(--v-primary-base)"
                            size="40"
                        />
                    </div>
                    <div v-else>
                        <div v-if="component.select_customer()" class="getup">
                            <v-select
                                v-model="screen_data.user_id_to_deliver_facturae"
                                label="Selecciona cliente"
                                :items="screen_data.client_users_facturae"
                                outlined
                                item-value="id"                
                                dense
                            >
                            <template v-slot:selection= "data">  
                                {{ data.item.username }}
                            </template>
                            <template v-slot:item="data">
                                {{ data.item.username }}
                            </template>
                            </v-select>
                            <p v-if="!component.screen_data.is_tax_data_filled" class="nota">
                                * Es necesario rellenar los datos fiscales del cliente, previamente en la pantalla de Usuarios.
                            </p>
                        </div>
                        
                        <div v-if="component.screen_data.is_company_selector_visible" class="getup">
                            <v-select
                                v-model="screen_data.selected_company_id"
                                label="Selecciona una empresa"
                                :items="screen_data.user_companies"
                                :disabled="!component.screen_data.is_tax_data_filled"
                                outlined
                                item-value="id"                
                                dense
                            >
                            <template v-slot:selection= "data">  
                                {{ data.item.name }}
                            </template>
                            <template v-slot:item="data">
                                {{ data.item.name }}
                            </template>
                            </v-select>
                            <p v-if="!component.screen_data.is_tax_data_filled" class="nota">
                                * Primero es necesario completar sus datos fiscales en la pantalla 'Mis Datos'.
                            </p>
                        </div>
                        
                        <div v-if="component.is_distributor()" class="getup">
                            <v-select 
                                v-model="screen_data.user_id_to_deliver_contract"
                                class="mt-2"
                                label="Selecciona un usuario"
                                :items="screen_data.distributor_users"
                                outlined
                                item-text="username"
                                item-value="id"
                                dense
                            ></v-select>
                        </div>
                        <div v-for="(service, key) in screen_data.services" :key="key" class="item-service-and-plan">
                            <div class="item-service" v-if="service.length>0" @click="component.toggleDropdown(key)">
                                <div class="service-name">
                                    {{ component.getServiceName(key) }}
                                </div>
                                <div v-if="screen_data.selected_services[key].dropdown || screen_data.selected_services[key].selected_plan_name!=''" class="service-type">
                                    {{ component.getServiceType(key) }}
                                </div>
                                <div style="display: flex; margin-left: auto;">
                                    <span v-if="screen_data.selected_services[key].dropdown || screen_data.selected_services[key].selected_plan_name !=''" class="service-order">
                                        Precio (sin IVA)
                                    </span>
                                    <span v-else class="service-order">Selecciona un plan</span>
                                    &nbsp;
                                    <img :class="screen_data.selected_services[key].dropdown? 'rotate-img': null" src="@/assets/arrow_drop_down_5.svg"/>
                                </div>
                            </div>
                            <div class="prices" v-if="screen_data.selected_services[key].dropdown">
                                <div 
                                    v-for="(plan, i) in service" 
                                    :key="i" 
                                    :class="['price', { selected: plan.selected }]"
                                    @click="component.togglePlanSelection(key, plan)"
                                >
                                    <div v-if="key!='facturae_credits' || screen_data.is_open_info_extra_companies"><!-- fila 1  --> <!-- primer if -->
                                        <div class="item-plan">
                                            <div class="plan-name">
                                                <AppIcon :src="require('@/assets/check_circle_2.svg')" :size="21" class="img" v-if="screen_data.selected_services[key].selected_plan_name==plan.name" :preserveColors="true"/>
                                                <AppIcon :src="require('@/assets/icon.svg')" :size="21" class="img" v-else :preserveColors="true"/>
                                                <div :class="{
                                                    'text': true,
                                                    'selected': screen_data.selected_services[key].selected_plan_name == plan.name,
                                                    }"
                                                >
                                                    {{ plan.name }}
                                                </div>
                                            </div>
                                            <div class="quantity-plan">
                                                <span v-if="key != 'facturae_credits' && key != 'working_hours'" class="text">
                                                    {{ component.getDescriptionOfThePlan(key, plan) }}
                                                </span>
                                            </div>
                                            <div class="users-included-plan">
                                                <span 
                                                    v-if="key == 'facturae_credits' && screen_data.is_open_info_extra_companies"
                                                    class="text"
                                                >
                                                    Coste por {{ component.getDescriptionOfThePlan(key, plan) }}
                                                </span>
                                                <span v-else-if="got_feature('feature_purchase_extra_users') && component.hasVisibleExtraUsers()" class="text">
                                                    Usuarios incluidos: <span class="small-text">{{ plan.name !='Enterprise' ? plan.limit_users : 'Ilimitados' }}</span>
                                                </span>
                                            </div>
                                            <div class="more-info-button-plan">
                                                <!-- esto se deja para mantener el espacio igual -->
                                            </div>
                                            <div class="price-plan"
                                                :class="{
                                                    'plan-price': true,
                                                    'selected': screen_data.selected_services[key].selected_plan_name == plan.name,
                                                }"
                                            >
                                                <span 
                                                    v-if="key == 'facturae_credits'" 
                                                    :class="screen_data.selected_services[key].selected_plan_name == plan.name? 'text selected' : 'text'">
                                                    {{ component.coin_format(screen_data.companies_eInvoice * plan.price) }}
                                                </span>
                                                <span 
                                                    v-else 
                                                    :class="screen_data.selected_services[key].selected_plan_name == plan.name? 'text selected' : 'text'"
                                                >
                                                    {{ component.coin_format(plan.price) }}
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            v-if="key == 'facturae_credits'" 
                                            class="item-plan"
                                        >
                                            <div class="plan-name">
                                                <!-- esto se deja para mantener el espacio igual -->
                                            </div>
                                            <div class="quantity-plan">
                                                <!-- esto se deja para mantener el espacio igual -->
                                            </div>
                                            <div class="users-included-plan">
                                                <span v-if="key=='facturae_credits'" class="bold-text">Empresas Adicionales: </span>
                                            </div>
                                            <div class="more-info-button-plan">
                                                <!-- esto se deja para mantener el espacio igual -->
                                            </div>
                                            <div class="price-plan">
                                                <input
                                                    v-model.number="screen_data.companies_eInvoice"
                                                    @click.stop
                                                    type="number" 
                                                    class="incrementer" 
                                                    :disabled="component.isAvailableTheIncrementerOfCompanies()"
                                                    min="1"
                                                    @input="component.calculateTotalToPay()"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="key=='facturae_credits' || !screen_data.is_open_info_extra_companies" class="item-plan">
                                        <div class="plan-name">
                                            <AppIcon :src="require('@/assets/check_circle_2.svg')" :size="21" class="img" :preserveColors="true"/>
                                            <span class="text selected">
                                                {{ plan.name }}
                                            </span>
                                        </div>
                                        <div class="quantity-plan">
                                            <span v-if="key != 'facturae_credits'" class="text">
                                                {{ component.getDescriptionOfThePlan(key, plan) }}
                                            </span>
                                        </div>
                                        <div class="users-included-plan">
                                            <span v-if="key=='facturae_credits'"class="text">
                                                Empresas adicionales: <span class="small-text">{{ screen_data.companies_eInvoice }}</span>
                                            </span>
                                            <span v-else class="text">
                                                Usuarios Incluidos: <span class="small-text">{{ plan.name !='Enterprise' ? plan.limit_users : 'Ilimitados' }}</span>
                                            </span>
                                        </div>
                                        <div class="more-info-button-plan">
                                            <AppIcon :src="require('@/assets/edit_extra_companies.svg')" :size="29" v-if="key == 'facturae_credits'" :preserveColors="true"/>
                                        </div>
                                        <div class="price-plan">
                                            <span 
                                                v-if="key == 'facturae_credits'"
                                                class="text selected"
                                            >
                                                {{ component.coin_format(screen_data.companies_eInvoice * plan.price) }}
                                            </span>
                                            <span 
                                                v-else
                                                class="text selected"
                                            >
                                                {{ component.coin_format(plan.price) }}
                                            </span>
                                        </div>
                                    </div>

                                    <div
                                        v-if="got_feature('feature_purchase_extra_users') && component.hasVisibleExtraUsers() && screen_data.selected_services[key].selected_plan_name == plan.name && (key != 'facturae_credits' || key == 'facturae_credits' && screen_data.is_open_info_extra_users) && plan.name != 'Enterprise'"
                                        :style="{
                                            borderTop: '1px solid var(--v-primary-base)',
                                            borderBottom: i === service.length - 1 ? 'none' : '1px solid var(--v-primary-base)',
                                        }"
                                    ><!-- fila 2 usuarios  -->
                                        <div class="item-plan"> <!-- div 1-->
                                            <div class="plan-name">
                                                <!-- esto se deja para mantener el espacio igual -->
                                            </div>
                                            <div class="quantity-plan">
                                                <!-- esto se deja para mantener el espacio igual -->
                                            </div>
                                            <div class="users-included-plan">
                                                <span class="text">
                                                    Coste por usuario {{ screen_data.extraUsersScreenData[key].extra_users_price }} €/plan
                                                </span>
                                            </div>
                                            <div class="more-info-button-plan">
                                                <!-- esto se deja para mantener el espacio igual -->
                                            </div>
                                            <div class="price-plan">
                                                <span class="text-users">
                                                    {{screen_data.extraUsersScreenData[key].extra_users_price * screen_data.extraUsersScreenData[key].selected_extra_users}} €
                                                </span>
                                            </div>
                                        </div>

                                        <div class="item-plan"> <!-- div 2-->
                                            <div class="plan-name">
                                                <span class="text-users">
                                                    Usuarios Activos: <span class="small-text-users">{{ screen_data.extraUsersScreenData[key].extra_users_num }}</span>
                                                </span>
                                            </div>
                                            <div class="quantity-plan">
                                                <!-- esto se deja para mantener el espacio igual -->
                                            </div>
                                            <div class="users-included-plan">
                                                <span class="text">
                                                    Usuarios Adicionales:
                                                </span>
                                            </div>
                                            <div class="more-info-button-plan">
                                                <!-- esto se deja para mantener el espacio igual -->
                                            </div>
                                            <div class="price-plan">
                                                <input
                                                    v-model.number="screen_data.extraUsersScreenData[key].selected_extra_users"
                                                    @click.stop
                                                    type="number" 
                                                    class="incrementer"
                                                    :disabled="screen_data.extraUsersScreenData[key].show === false"
                                                    :min="Math.max(screen_data.extraUsersScreenData[key].extra_users_num - plan.limit_users, 0)"
                                                    @input="component.updateNumExtraUsers(key, screen_data.extraUsersScreenData[key].selected_extra_users)"
                                                />
                                            </div>
                                        </div>
                                        <div class="item-plan" v-if="screen_data.extraUsersScreenData[key].validation_error"> <!-- div 2-->
                                            <span class="text-users">
                                                <p class="small-text-users-error mt-2">{{ screen_data.extraUsersScreenData[key].validation_error }}</p>
                                            </span>
                                        </div>
                                    </div>
                                    <div v-else-if="got_feature('feature_purchase_extra_users') && component.hasVisibleExtraUsers() && key == 'facturae_credits' && !screen_data.is_open_info_extra_users && screen_data.selected_services[key].selected_plan_name == plan.name">
                                        <div class="item-plan" style="border-top: 1px solid var(--v-primary-base)">
                                            <div class="plan-name">
                                                <span class="text-users">
                                                    Usuarios activos: <span class="small-text-users">{{ screen_data.extraUsersScreenData[key].extra_users_num }}</span>
                                                </span>
                                            </div>
                                            <div class="quantity-plan">
                                                <!-- esto se deja para mantener el espacio igual -->
                                            </div>
                                            <div class="users-included-plan">
                                                <span class="text">
                                                    Usuarios adicionales: <span class="small-text">{{screen_data.extraUsersScreenData[key].selected_extra_users}}</span>
                                                </span>
                                            </div>
                                            <div class="more-info-button-plan">
                                                <AppIcon :src="require('@/assets/edit_extra_users.svg')" :size="26" :preserveColors="true"/>
                                            </div>
                                            <div class="price-plan">
                                                <span class="text-users">
                                                    {{screen_data.extraUsersScreenData[key].extra_users_price * screen_data.extraUsersScreenData[key].selected_extra_users}} €
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="screen_data.selected_services[key].selected_plan_name != ''" class="prices">
                                <div v-for="plan in screen_data.services[key]" class="price">
                                    <div v-if="plan.service_id == screen_data.selected_services[key].service_id" @click="component.togglePlanSelection(key, plan)" style="width: 100%">
                                        <div class="item-plan">
                                            <div class="plan-name">
                                                <AppIcon :src="require('@/assets/check_circle_2.svg')" :size="21" class="img" :preserveColors="true"/>
                                                <span class="text selected">
                                                    {{ plan.name }}
                                                </span>
                                            </div>
                                            <div class="quantity-plan">
                                                <span v-if="key != 'facturae_credits'" class="text">
                                                    {{ component.getDescriptionOfThePlan(key, plan) }}
                                                </span>
                                            </div>
                                            <div class="users-included-plan">
                                                <span v-if="key=='facturae_credits'"class="text">
                                                    Empresas adicionales: <span class="small-text">{{ screen_data.companies_eInvoice }}</span>
                                                </span>
                                                <span v-else-if="got_feature('feature_purchase_extra_users') && component.hasVisibleExtraUsers()" class="text">
                                                    Usuarios Incluidos: <span class="small-text">{{ plan.name !='Enterprise' ? plan.limit_users : 'Ilimitados' }}</span>
                                                </span>
                                            </div>
                                            <div class="more-info-button-plan">
                                                <AppIcon :src="require('@/assets/edit_extra_companies.svg')" :size="26" v-if="key == 'facturae_credits' " :preserveColors="true" />
                                            </div>
                                            <div class="price-plan">
                                                <span 
                                                    v-if="key == 'facturae_credits'"
                                                    class="text selected"
                                                >
                                                    {{ component.coin_format(screen_data.companies_eInvoice * plan.price) }}
                                                </span>
                                                <span 
                                                    v-else
                                                    class="text selected"
                                                >
                                                    {{ component.coin_format(plan.price) }}
                                                </span>
                                            </div>
                                        </div>
                                        <div 
                                            v-if="got_feature('feature_purchase_extra_users') && component.hasVisibleExtraUsers() && plan.name != 'Enterprise'"
                                            class="item-plan" style="border-top: 1px solid var(--v-primary-base)"
                                        >
                                            <div class="plan-name">
                                                <span class="text-users">
                                                    Usuarios activos: <span class="small-text-users">{{ screen_data.extraUsersScreenData[key].extra_users_num }}</span>
                                                </span>
                                            </div>
                                            <div class="quantity-plan">
                                                <!-- esto se deja para mantener el espacio igual -->
                                            </div>
                                            <div class="users-included-plan">
                                                <span class="text">
                                                    Usuarios adicionales: <span class="small-text">{{screen_data.extraUsersScreenData[key].selected_extra_users}}</span>
                                                </span>
                                            </div>
                                            <div class="more-info-button-plan">
                                                <AppIcon :src="require('@/assets/edit_extra_users.svg')" :size="26" :preserveColors="true"/>
                                            </div>
                                            <div class="price-plan">
                                                <span class="text-users">
                                                    {{screen_data.extraUsersScreenData[key].extra_users_price * screen_data.extraUsersScreenData[key].selected_extra_users}} €
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-else-if="screen_data.view == 'select_payment_method'"
                    class="card-body-left"
                    :style="{
                        width: screen_data.payment_method == 'card' ? '600px' :'660px',
                    }"
                >
                    <div role="button" class="back-box" @click="component.screen_data.view = 'select_plan'">
                        <AppIcon :src="require('@/assets/keyboard_backspace.svg')" :size="14" :preserveColors="true"/> 
                        Atrás
                    </div>
                    <div class="payment-box">
                        <div style="font-size: 16px; font-weight: 500; color: #565656">Selecciona una forma de pago</div>
                        <div class="div-row" style="margin-top: 10px">
                            <button
                            :class="['payment-method-button', 'center-div', { selected: screen_data.payment_method == 'transfer' }]"
                                @click="component.changeThePaymentMethod('transfer')"
                            >
                                <AppIcon :src="require('@/assets/send_money_color.svg')" :size="20" v-if="screen_data.payment_method == 'transfer'" />
                                <AppIcon :src="require('@/assets/send_money.svg')" :size="20" v-else-if="screen_data.payment_method == 'card'" :preserveColors="true" />
                                <span>&nbsp;Transferencia</span>
                            </button>
                            <button
                                v-if="got_feature('feature_pay_with_card')"
                                :class="['payment-method-button', 'center-div', { selected: screen_data.payment_method == 'card' }]"
                                style="margin-left: 15px;"
                                @click="component.changeThePaymentMethod('card')"
                            >
                                <AppIcon :src="require('@/assets/credit_card.svg')" :size="20" v-if="screen_data.payment_method == 'transfer'" />
                                <AppIcon :src="require('@/assets/credit_card_color.svg')" :size="20" v-else-if="screen_data.payment_method == 'card'" />
                                <span>&nbsp;Tarjeta</span>
                            </button>
                        </div>
                    </div>
                        <div v-if="screen_data.payment_method == 'transfer'">
                            <div style="font-size: 16px; font-weight: 500; color: #565656">Cuenta de Inmatic</div>
                            <div style="font-size: 16px; font-weight: 600; color: #3D3D3D; margin-top: 10px;">BANCO SABADELL IBAN: ES04 0081 0400 1100 0123 0926</div>
                            <div style="font-size: 16px; font-weight: 400; color: #565656; margin-top: 10px;">En el beneficiario indica Coneptum S.L. En el concepto indique usuario y el plan seleccionado.</div>
                            <v-file-input 
                                v-model="screen_data.payment_file"
                                outlined
                                prepend-icon=""
                                prepend-inner-icon="mdi-paperclip"
                                name="uploader"
                                label="Adjuntar justificante de pago"
                                class="file-input--outlined rounded-lg pb-2"
                                style="margin-top: 50px"
                                hide-details
                                dense
                                @change="component.onFileChange()"
                            />
                            <v-checkbox v-model="screen_data.is_the_contract_accepted"  class="my-0 py-0" hide-details>
                                <template v-slot:label>
                                    <span class="small-font">
                                        He leído y acepto la
                                        <PolicyDialogLink 
                                            name="Adhesión a la prestación de servicios"
                                        >
                                            <LegalContract 
                                                :params="{
                                                    postal_address: screen_data.user_data.postal_address,
                                                    province: screen_data.user_data.province,
                                                    bussnies_id: screen_data.user_data.bussnies_id,
                                                    business_name: screen_data.user_data.business_name,
                                                    name: screen_data.user_data.name,
                                                    date: screen_data.contract_date,
                                                    services_selected: component.getServicesForLegalContract()
                                                }"
                                            />
                                        </PolicyDialogLink>
                                    </span>
                                </template>
                            </v-checkbox>
                        </div>
                        <div v-if="screen_data.payment_method == 'card'" class="card-box">
                            <div>Serás redirigido a Stripe, nuestra pasarela de pago segura. En Stripe ingresarás los datos de tu tarjeta de forma protegida.</div>
                            <v-radio-group
                                v-if="screen_data.used_card.last4"
                                v-model="screen_data.used_card.use_old_card"
                                class="my-0 py-0"
                                hide-details
                                style="margin-left:0.75rem;"
                            >
                                <v-radio
                                    :label="`Pagar con la Tarjeta acabada en ****${screen_data.used_card.last4}`"
                                    :value="true"
                                    class="my-0 py-0"
                                />
                                <div style="height:20px;">&nbsp;</div>
                                <v-radio
                                    label="Pagar con una nueva Tarjeta"
                                    :value="false"
                                    class="my-0 py-0"                                                
                                />
                            </v-radio-group>
                        </div>
                </div>
                <div 
                    class="card-body-right"
                    :style="{
                        width: screen_data.payment_method == 'card' ? '480px' :'420px',
                    }"
                >
                    <div v-if="screen_data.view == 'select_plan'" style="width: 100%;">
                        <div 
                            v-if="screen_data.user_data.available_features['feature_promotional_code']"
                            style="width: 100%"
                        >
                            <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                                <input
                                    :key="screen_data.key_promotional_code"
                                    v-model="screen_data.promotional_code"
                                    :style="{
                                        border: screen_data.success_message_for_promotional_code?'1px solid #049112' : screen_data.error_message_for_promotional_code? '1px solid #a70d0d' : '1px solid #262626',
                                        width: '245px',
                                        height: '32px',
                                        paddingLeft: '10px', 
                                        borderRadius: '5px',
                                    }"
                                    placeholder="¿Tienes un Código promocional?"
                                    class="promotional-code-2"
                                    :class="{shake: screen_data.error_message_for_promotional_code }"
                                    @keyup.enter="component.getServices()"
                                />
                                <button
                                    style="height: 32px; width:65px; background-color: #565656; border-radius: 8px;"
                                    @click="component.getServices()"
                                >
                                    <span style="font-weight: 500; font-size: 14px; color: white">Añadir</span>
                                </button>
                            </div>
                            <div 
                                v-if="screen_data.success_message_for_promotional_code || screen_data.error_message_for_promotional_code"
                                style="padding-left: 10px;"
                            >
                                <span 
                                    v-if="screen_data.success_message_for_promotional_code"
                                    style="font-weight: 400; font-size: 11px; color: #003407"
                                >
                                    El código ha sido aplicado con éxito
                                </span>
                                <span 
                                    v-else-if="screen_data.error_message_for_promotional_code"
                                    style="font-weight: 400; font-size: 11px; color: #A70D0D"
                                >
                                    El código usado no es válido
                                </span>
                            </div>
                        </div>
                        <div class="div-row" style="justify-content: space-between; align-items: center; margin-top: 40px;">
                            <div style="font-size: 24px; font-weight: 600; color: #262626">TOTAL</div>
                            <div style="font-size: 16px; font-weight: 600; color: #565656">
                                {{screen_data.taxes.name}} ({{ screen_data.taxes.percentage }}%)
                            </div>
                        </div>
                        <div class="div-total">
                            <span style="font-size: 16px; font-weight: 600; margin-right: 10px; color: #262626;">
                                {{ component.coin_format(screen_data.total_price) }}
                            </span>
                        </div>
                        <button
                            :class="[component.isNextButtonEnabled() ? 'button-siguiente' : 'button-siguiente disabled']"
                            :disabled="!component.isNextButtonEnabled()"
                            style="margin-top: 15px"
                            @click="component.validateSelectPlan()"
                        >
                            Siguiente
                        </button>
                        <div class="div-row" style="margin-top: 60px">
                            <span class="defualt-text">Fin del contrato:</span>&nbsp;<span class="date">{{ screen_data.end_date }}</span>
                        </div>
                        <div class="div-row" style="margin-top: 15px;">
                            <span class="defualt-text">
                                {{ screen_data.contract_modal_msg }}
                            </span>
                        </div>
                        <div class="div-row" style="margin-top: 15px">
                            <a href="https://inmatic.ai/tarifas" target="_blank"><AppIcon :src="require('@/assets/info.svg')" :size="22" :preserveColors="true"/></a>
                        </div>
                    </div>
                    <div v-if="screen_data.view == 'select_payment_method'" style="width: 100%;">
                        <div
                            style="width: 100%; display: flex;"
                        >
                            <div
                                :style="{
                                    width: screen_data.payment_method == 'card' && screen_data.isSummaryDisplayed? '100%': screen_data.payment_method == 'card' ? '60%': '100%',
                                }"
                            >
                                <div class="summary" @click="component.toggleSummaryDisplayed()">
                                    <div class="summary_text">
                                        <span v-if="component.several_selected_plans()">Planes anuales contratados</span>
                                        <span v-else>Plan anual contratado</span>
                                    </div>
                                    <AppIcon :src="require('@/assets/arrow_drop_down_5.svg')" :size="10" class="screen_data.isSummaryDisplayed? 'rotate-img': null" v-if="screen_data.payment_method != 'card'" :preserveColors="true"/>
                                    <AppIcon :src="require('@/assets/horizontal_arrow.svg')" :size="10" class="screen_data.isSummaryDisplayed? 'rotate-img': null" v-else :preserveColors="true"/>
                                </div>
                                <div 
                                    class="summary_services" 
                                    v-if="screen_data.payment_method == 'transfer' && screen_data.isSummaryDisplayed || screen_data.payment_method == 'card'"
                                >
                                    <div 
                                        class="summary_item" 
                                        v-for="(value, key) in screen_data.selected_services" 
                                        v-if="value.selected_plan_name != ''"
                                        :key="key"
                                    >
                                        <template v-for="plan in screen_data.services[key].filter(plan => plan.name === value.selected_plan_name)" style="width: 100%;">
                                            <div 
                                                class="summary_colum1"
                                                :style="{
                                                    width: screen_data.payment_method == 'card' && !screen_data.isSummaryDisplayed? '50%' : '35%'
                                                }"
                                            >
                                                <div class="summary_service">
                                                    {{ component.getServiceName(key, true) }}
                                                </div>
                                                <div class="summary_plan">
                                                    {{ plan.name }}
                                                </div>
                                            </div>
                                            <div 
                                                v-if="screen_data.payment_method == 'transfer' || (screen_data.payment_method == 'card' && screen_data.isSummaryDisplayed)"
                                                class="summary_colum2"
                                            >
                                                <div class="summary_text_users">
                                                    <span v-if="key != 'facturae_credits'">
                                                        {{ component.getSummaryDescription(key, plan) }}
                                                    </span>
                                                    <span v-else>
                                                        Empresas Adic. {{ screen_data.companies_eInvoice }}
                                                    </span>
                                                </div>
                                                <div v-if="got_feature('feature_purchase_extra_users') && component.hasVisibleExtraUsers()" class="summary_text_users">
                                                    {{screen_data.extraUsersScreenData[key].selected_extra_users > 1 ? 'Usuarios' : 'Usuario'}} Adic. {{ screen_data.extraUsersScreenData[key].selected_extra_users }}
                                                </div>
                                            </div>
                                            <div class="summary_colum3">
                                                <div class="summary_price">
                                                    <span style="font-size: 14px; font-weight: 600; color: #4F4F4F">
                                                        {{ key == 'facturae_credits' ? component.coin_format(screen_data.companies_eInvoice * plan.price) : component.coin_format(plan.price) }}
                                                    </span>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <!-- QUITAR!!! -->
                            <div 
                                v-if="false && screen_data.payment_method == 'card'"
                                :style="{
                                    width: screen_data.is_auto_renewal_displayed? '35%' : '15%'
                                }"
                            >
                                <div class="summary" @click="component.toggleAutoRenewalDisplayed()">
                                    <div class="summary_text">
                                        <span v-if="screen_data.is_auto_renewal_displayed">Autorenovación</span>
                                        <span v-else>AR</span>
                                    </div>
                                    <AppIcon :src="require('@/assets/horizontal_arrow.svg')" :size="10" class="screen_data.is_auto_renewal_displayed? 'rotate-img': null" :preserveColors="true"/>
                                </div>
                                <div
                                    v-for="(value, key) in screen_data.selected_services" 
                                    v-if="value.selected_plan_name != ''"
                                    style="height: 40px; margin-bottom: 12px; display:flex; align-items: center; justify-content: space-between;"
                                >
                                    <span 
                                        v-if="screen_data.is_auto_renewal_displayed"
                                        style="font-weight: 500; font-size: 14px; color: #565656; width: 75px;"
                                    >
                                        {{ screen_data.selected_services[key].is_auto_renewal_active? 'Activada' : 'Desactivada' }}
                                    </span>
                                    <!-- boton activo -->
                                    <div
                                        v-if="screen_data.selected_services[key].is_auto_renewal_active"
                                        style="width: 52px; height: 32px; display:flex; align-items: center; justify-content: end; background-color: #894CD1; border-radius: 100px;"
                                        @click="component.toggleIsAutoRenewalActive(key)"
                                    >
                                        <div style="width: 24px; height: 24px; border-radius: 100px; background-color: #FFFFFF; margin-right: 4px;">

                                        </div>
                                    </div>
                                    <!-- boton desactivo -->
                                    <div 
                                        v-else
                                        style="width: 52px; height: 32px; display:flex; align-items: center; background-color: #e7e7e7; border-radius: 100px;"
                                        @click="component.toggleIsAutoRenewalActive(key)"
                                    >
                                        <div style="width: 16px; height: 16px; border-radius: 100px; background-color: #FFFFFF; margin-left: 9px;">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="div-row" style="justify-content: space-between; align-items: center; margin-top: 20px;">
                            <div style="font-size: 24px; font-weight: 600; color: #262626">TOTAL</div>
                            <div style="font-size: 16px; font-weight: 600; color: #565656">
                                {{screen_data.taxes.name}} ({{ screen_data.taxes.percentage }}%)
                            </div>
                        </div>
                        <div class="div-total">
                            <span style="font-size: 16px; font-weight: 600; margin-right: 10px; color: #262626;">
                                {{ component.coin_format(screen_data.total_price) }}
                            </span>
                        </div>
                        <div style="width: 100%; display: flex; align-items: center; margin-top: 15px;">
                            <button
                                v-if="screen_data.payment_method == 'transfer'"
                                :class="[component.isContinuePaymentWithTransEnabled() ? 'button-continue-payment' : 'button-continue-payment disabled']"
                                :disabled="!component.isContinuePaymentWithTransEnabled()"
                                @click="() => component.payWithTransfer()"
                            >
                                <span style="font-size: 14px; font-weight: 500; color: var(--v-neutral-base)">Continuar con el pago</span>
                            </button>
                            <button
                                v-else-if="screen_data.payment_method == 'card'"
                                class="button-continue-payment"
                                @click="() => component.payWithCard()"
                            >
                                <span style="font-size: 14px; font-weight: 500; color: var(--v-neutral-base)">Continuar con el pago</span>
                            </button>
                            <AppIcon :src="require('@/assets/stripe.svg')" :size="67" style="margin-left: 40px;" v-if="screen_data.payment_method == 'card'" :preserveColors="true"/>
                        </div>
                        <div class="div-row" style="margin-top: 30px; align-items: center;">
                            <a href="https://inmatic.ai/tarifas" style="display: inline-flex;"><AppIcon :src="require('@/assets/info.svg')" :size="22" :preserveColors="true"/></a>
                            <span class="defualt-text" style="margin-left: 10px;">Fin del contrato:</span>&nbsp;<span class="date">{{ screen_data.end_date }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body" v-if="screen_data.view == 'waiting_screen'">
                <div v-if="screen_data.payment_method == 'transfer'" class="final-box">
                    <div class="final-box-flag">
                        <i class="mdi mdi-loading mdi-spin"></i>
                    </div>
                    <div class="final-box-title loading">Cargando...</div>
                    <div class="final-box-message">Por favor, espera un momento.</div>
                </div>
                <div v-if="screen_data.payment_method == 'card' && screen_data.used_card.use_old_card" class="final-box">
                    <div class="final-box-flag">
                        <i class="mdi mdi-loading mdi-spin"></i>
                    </div>
                    <div class="final-box-title loading">Conectando con Stripe...</div>
                    <div class="final-box-message">Por favor, espera un momento.</div>
                </div>
                <div v-if="screen_data.payment_method == 'card' && !screen_data.used_card.use_old_card" class="final-box">
                    <div class="final-box-flag">
                        <p class="clock">{{ component.remaining_clock() }}</p>
                    </div>
                    <div class="final-box-title loading">Tiempo restante para completar el pago</div>
                    <div class="final-box-message">Tu información será procesada de forma segura a través de Stripe, completa los datos en la ventana emergente.</div>
                </div>
            </div>

            <div class="card-body" v-if="screen_data.view == 'final_result_screen'">
                <div style="width: 100%; display: flex; flex-direction: column; align-items: center;">
                    <div style="margin-top: 40px;">
                        <AppIcon :src="require('@/assets/check_circle_strong_green.svg')" :size="40" v-if="screen_data.success" :preserveColors="true"/>
                        <AppIcon :src="require('@/assets/gpp_bad.svg')" :size="40" v-else :preserveColors="true"/>
                    </div>
                    <p :class="screen_data.success?'final-box-title done':'final-box-title fail'">
                        {{ screen_data.title }}
                    </p>
                    <div class="final-box-message">{{ screen_data.message }}</div>
                    <button class="end-button" @click="handleFinish">Finalizar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters, mapState } from "vuex";
import { mapFields } from 'vuex-map-fields';
import PolicyDialogLink from "./WelcomeSteps/PolicyDialogLink";
import LegalContract from "./WelcomeSteps/LegalContract";
import { vuexPrefix } from "../store/vuex_utils";
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import ContractSelectPlanPopup from '@/components/ContractSelectPlanPopup.vue';
import { sync_command_dispatcher, query_dispatcher_abort } from "@/api/client";
import { DeliverAndCreateChargeForService } from '@/modules/revenue/app/DeliverAndCreateChargeForService'
import { ServicesPricesFiscalPositionQuery } from '@/modules/revenue/app/ServicesPricesFiscalPositionQuery';
import { DistributorUsersQuery } from '@/modules/revenue/app/DistributorUsersQuery';
import { ClientUsersQuery } from '@/modules/revenue/app/ClientUsersQuery';
import { S3Repository } from '@/modules/shared/infra/S3Repository';
import awsconfig from '../aws-exports';
import debounce from 'lodash/debounce';
import { IsValidPaymentFileQuery } from "@/modules/revenue/app/IsValidPaymentFileQuery";
import { query_dispatcher } from '@/api/client';
import { ApiContractPopup } from "@/modules/revenue/infra/ApiContractPopup";
import { ContractPopup } from "@/modules/revenue/domain/ContractPopup";
import { ContractPopupAllCommands } from "@/modules/revenue/app/ContractPopupAllCommands";
import { user } from "@/api/user";
import { boolean, forEach } from "mathjs";
import { excelFileChosen } from "@/modules/invoices/domain/Invoice";
import { withSSRContext } from "aws-amplify";
import { MemoryServiceDeliveryRepo } from "@/modules/revenue/infra/MemoryServiceDeliveryRepo";
import { GetExtraUsersDataQuery } from '@/modules/revenue/app/GetExtraUsersDataQuery';
import { UpdateExtraUsersDataQuery } from '@/modules/revenue/app/UpdateExtraUsersDataQuery';
import { GetExtraUsersTotalPriceQuery  } from '@/modules/revenue/app/GetExtraUsersTotalPriceQuery';

const default_remaining_time = 300; // 5 minutes in seconds

export default {
    name: 'ContractPopup',
    components: {
        PolicyDialogLink,
        LegalContract,
        AppModalContainer,
        ContractSelectPlanPopup
    },

    data() {
        const contract_popup = new ContractPopup()
        return {
            screen_data: contract_popup,
            component: null,
        }
    },

    async created() {
        // configuración de aws
        let creds = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: awsconfig['aws_cognito_identity_pool_id']
        });
        creds.params.Logins = creds.params.Logins || {};
        creds.params.Logins['cognito-idp.eu-west-1.amazonaws.com/' + awsconfig['aws_user_pools_id']] =  this.session_information.signInUserSession.idToken.jwtToken;
        creds.expired = true;
        AWS.config.update({
            region: awsconfig['aws_user_files_s3_bucket_region'],
            credentials: creds,
        });
        //lógica
        let sd_repo = new MemoryServiceDeliveryRepo(this.userData.all_contracts);
        this.component = new ContractPopupAllCommands(this.screen_data, new ApiContractPopup(), new S3Repository(AWS), sd_repo)
        this.component.addComputedFields(this.userData, this.contract_modal_msg, this.contract_modal_distributor, this.contract_modal_facturae_client, this.contract_modal_working_hours_client, this.is_company_selector_visible, this.is_tax_data_filled, this.can_show_document_services_and_banks)
        await this.component.run()
    },

    beforeDestroy() {
        window.removeEventListener('message', this.message_listener)
    },
    computed: {
        ...mapGetters({
            userData: "me/userData",
            contract_modal_msg: "dialog_payment/contract_modal_msg",
            contract_modal_distributor: "dialog_payment/contract_modal_distributor",
            contract_modal_facturae_client: "dialog_payment/contract_modal_facturae_client",
            contract_modal_working_hours_client: "dialog_payment/contract_modal_working_hours_client",
            is_company_selector_visible: "dialog_payment/is_company_selector_visible",
            is_tax_data_filled: "dialog_payment/is_tax_data_filled",
            can_show_document_services_and_banks: "dialog_payment/can_show_document_services_and_banks",
            got_feature: 'got_feature',
        }),
        ...mapState(['session_information']),
        ...mapFields('dialog_payment', ['show_contract_modal']),
    },
    methods: {
        ...mapActions({
            forceRefreshUserData: 'me/forceRefreshUserData',
        }),
        async handleFinish() {
            this.show_contract_modal = false;

            // Si el pago fue exitoso, actualizar los datos del usuario sin recargar la página
            if (this.screen_data.success) {
                await this.forceRefreshUserData();
            }
        }
    }
}
</script>

<style>

.clock {
    font-size: 40px;
    color: #9F6BE1;
    font-weight: 600;
    letter-spacing: 2px;
}

.nota {
    font-size: 16px;
    color: #565656;
}
.center-div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.end-button {
    width: 182px;
    height: 40px;
    margin-top: 40px;
    background-color: #454545;
    color: var(--v-neutral-base);
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
}
.button-fill {
    width: 182px;
    height: 40px;
    border-radius: 8px;
    background-color: var(--v-primary-base);
    color: white
}
.button-not-fill{
    width: 182px;
    height: 40px;
    border-radius: 8px;
    background-color: white;
    color: var(--v-primary-base);
    border: 1px solid var(--v-primary-base);
    box-sizing: border-box;
}
.final-box {
    width: 100%;
    padding: 32px 24px 48px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.final-box-flag {
    margin-top: 50px;
    text-align: center;
    font-size: 50px;
}
.final-box-title {
    font-size: 26px;
    font-weight: 600;
    color: #003407;
}

.final-box-title.done {
    margin-top: 60px;
    color: #003407;
}

.final-box-title.fail {
    margin-top: 60px;
    color: #4C0303;
}

.final-box-title.loading {
    color: #3D3D3D;
}

.final-box-message {
    width: 520px;
    text-align: center;
    margin-top: 10px;
    font-size: 16px;
    font-weight: 500;
    color: #565656
}

.final-box-actions{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 51px;
}
.getup {
    position:relative;
    top: -8px;
}
.success {
    color: #003407;
}
.failedV2 {
    color: #4c0303;
}

.payment-method-button {
    background-color: #F3F3F3;
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    height: 40px;
    font-weight: 500;
    color: #454545;
    cursor: pointer;
}
.payment-method-button.selected {
    background-color: #f9f6fe;
    border: 1px solid var(--v-primary-base);
    color: var(--v-primary-base);
}
.back-box {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 51px;
    font-weight: 700;
    font-size: 13px;
    color: #888888;
    cursor: pointer;
    user-select: none;
}

.payment-box {
    width: 100%;
    margin-bottom: 48px;
}

.transfer-box {
    width: 550px;
}

.small-letter-bold{
    color: #565656;
    font-size: 14px;
    font-weight: 500;
}

.small-letter{
    color: #565656;
    font-size: 12px;
    font-weight: 500;
    margin-right: 10px;
}

.incrementer {
    height: 27px;
    width: 71px;
    text-align: right;
    border: 1px solid #b0b0b0;
    background-color: #f3f3f3;
    font-size: 13px;
    font-weight: 400;
    color: #565656;
    border-radius: 3px;
}

.card-box {
    width: 550px;
    color: #6D6D6D;
}
.card-box > div:nth-child(1){
    font-size:16px;
    font-weight: 500;
    margin-bottom: 12px;
}
.card-box > div:nth-child(2){
    font-weight: 500;
    margin-bottom: 20px;
}
.card-box > div:nth-child(3){
    font-weight: 500;
}

.summary {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #D1D1D1;
    margin-bottom: 8px;
}
.summary_text {
    font-weight: 600;
    color: #454545;
}
.summary_services {
    display: flex;
    flex-direction: column;
    width: 100%;
}
.summary_item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    margin-bottom: 12px;
}
.summary_colum1 {
    width: 35%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
}
.summary_colum2 {
    width: 35%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
}
.summary_colum3 {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: end;
}
.summary_service {
    font-size: 16px;
    font-weight: 500;
    color: #565656;
}
.summary_details {
    font-size: 12px;
    font-weight: 500;
    color: #888888;
}
.summary_plan {
    font-size: 14px !important;
    font-weight: 500;
    color: #7339B7;
}
.summary_text_users {
    font-size: 12px !important;
    font-weight: 400;
    color: #565656;
}
.summary_included {
    font-size: 12px;
    font-weight: 400;
}
.summary_price {
    height: 32px;
    width:78px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: end;
    padding-right: 8px;
    border: 1px solid #B0B0B0;
    border-radius: 4px;
    color: #4F4F4F;
}

.popupV2 {
    width: 1080px;
    height: 600px;
    z-index: 2000; 
}

.row-bodyV2 {
    display:flex;
    flex-direction: row;
    width: 1080px;
    height: 530px;
    padding: 0px;
    position: relative;
    left: 12px;
}

.item-service:has(+ .prices) {
       margin-bottom: 0px;
}

.card-body-left .prices {
    border: 1px solid var(--v-primary-base);
    border-radius: 4px;
    margin-bottom: 18px;
}

.card-body-left .prices .usuarios {
    height: 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: right;
    border-top: 1px solid var(--v-primary-base);
}
.card-body-left .prices .usuarios + input {
    height: 32px;
    margin-right: 100px;
}
.card-body-left .prices .price {
    width:100%;
    display: flex;
    flex-direction: column;
    color: #565656;
}
.card-body-left .prices .price .plan-icon{
    padding-left: 10px;
    width: 40px;
    height: 40px;
    display:flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

/* estilos de cada fila de planes */

.plan-name{
    width: 30%; 
    display: flex; 
    align-items: center; 
    padding-left: 2px;
}

.plan-name .img{
    width: 21px; 
    height: 21px
}

.plan-name .text{
    padding-left: 15px;
    color: #4F4F4F;
    font-size: 16px;
    font-weight: 600;
}

.plan-name .text.selected{
    color: #7339B7;
}

.plan-name .text-users{
    font-weight: 500; 
    font-size: 12px; 
    color: #565656;
}

.plan-name .small-text-users{
    font-weight: 400; 
    font-size: 12px; 
    color: #565656;
}

.quantity-plan{
    width: 15%;
    height: 40px;
    display:flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    font-weight: 400;
    font-size: 14px;
}

.quantity-plan .text{
    font-weight: 400;
    font-size: 12px;
    color: #565656
}

.users-included-plan{
    width: 35%; 
    display: flex; 
    align-items: center;
}

.users-included-plan .text{
    font-weight: 500; 
    font-size: 12px; 
    color: #565656;
}

.users-included-plan .small-text{
    font-weight: 400; 
    font-size: 12px; 
    color: #565656;
}

.users-included-plan .bold-text{
    font-weight: 500; 
    font-size: 12px; 
    color: #565656;
}

.more-info-button-plan{
    width: 5%; 
    display: flex; 
    align-items: center;
}

.price-plan{
    width: 15%;
    display: flex;
    justify-content: flex-end;
    padding-right: 10px;
}

.price-plan .text{
    font-size: 16px;
    font-weight: 600;
    color: #4F4F4F;
}

.price-plan .text.selected{
    color: #7339B7;
}

.price-plan .text-users{
    font-size: 14px;
    font-weight: 500;
    color: #4F4F4F;
}

/* estilos de cada fila de planes */

.subbox1V2 .end-text {
    font-size: 14px;
    font-weight: 500;
    color: #565656;
}
.subbox1V2 .end-date {
    font-size: 14px;
    font-weight: 500;
    color: #300065;
}

.subbox2V2 {
    width: 372px;  
}
.subbox2V2 .sub1{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 13px;
}
.subbox2V2 .sub1 .total{
    font-size: 24px;
    font-weight: 600;
    color: #262626;
}
.subbox2V2 .sub1 .taxes{
    font-size: 16px;
    font-weight: 600;
    color: #565656;
}
.subbox2V2 .sub2{
    border: 1px solid #262626;
    border-radius: 4px;
    width: 372px;
    min-height: 32px;
    height: auto; 
    box-sizing: border-box;
    padding: 10px 32px 10px 32px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
}

.subbox2V2 .sub2 .total-to-pay {
    color: #262626;
    font-size: 16px;
    font-weight: 600;
    text-align: right;
} 
.subbox2V2 .sub3{

}
.subbox2V2 .sub3 button, .card-body-left .card-box button {
    background-color: #6E15DB;
    border: none;
    border-radius: 4px;
    padding: 10px 20px;
    /*width: 160px;*/
    height: 40px;
    font-weight: 500;
    color: var(--v-neutral-base);
    cursor: pointer;
    margin-top:15px;
}
.subbox2V2 .sub3 button.disabled, .card-body-left .card-box button.disabled {
    background-color: #B0B0B0;
    cursor: not-allowed;
}
.subbox3V2 {
    width: 372px;  
}
.subbox3V2 .sub1{
    font-size: 14px;
    font-weight: 500;
    color: #565656;
}
.subbox3V2 .sub2{
    margin-top: 17px;
    font-size: 20px;
}
.subbox4V2 {
    width: 372px;  
}
.subbox5V2 {
    width: 372px;  
    display:flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 10px;
}
.subbox6V2 {
    width: 372px;  
}
.v-dialog.contract-popup {
    border-radius: 8px !important;
    width: 600px !important;
}
.v-dialog.contract-popup.doble-contract {
    width: 920px !important;
}
.v-dialog.contract-popup.many-contract {
    width: 1300px !important;
}
.v-dialog.contract-popup .v-card__actions {
    padding-left:48px !important;
    padding-right:48px !important;
    padding-bottom: 10px !important;
}
.v-dialog.contract-popup.doble-contract .v-card__actions{
    padding-left:80px !important;
    padding-right:80px !important;
}
.v-dialog.contract-popup .v-card__text {
    padding-left:20px !important;
    padding-right:20px !important;
}
.v-dialog.contract-popup .v-card__text .dialog-content {
    padding-left:28px !important;
    padding-right:28px !important;
}
.v-dialog.contract-popup.doble-contract .v-card__text .dialog-content {
    padding-left:60px !important;
    padding-right:60px !important;
}
.v-dialog.contract-popup .v-card__text .dialog-intro{
    font-size:15px;
    font-weight: 300;
    text-align: center;
}
.v-dialog.contract-popup .v-card__text .contract-type {
    text-align: center;
    font-size: 20px;
    font-weight:700;
}
.v-dialog.contract-popup .file-input--outlined .v-input__prepend-inner .v-icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
}

.promotional-code-2{
    font-size: 13px;
    font-weight: 400;
    color: #454545;
    padding-left: 3px;
}

.promotional-code-2::placeholder{
    font-size: 13px;
    font-weight: 400;
    color: #888888;
    padding-left: 3px;
}

.promotional-code {
    width: 245px;
}

.promotional-code .v-input__slot{
    min-height: 32px !important;
}

.promotional-code input{
    padding: 0px;
    font-size: 14px;
}

.promotional-code .v-label{
    font-size: 13px;
    font-weight: 400;
    color: #888888;
}

.promotional-code.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
}

.v-dialog.contract-popup .v-input--radio-group .v-input__slot {
    margin-bottom: 0px !important;
}
.v-dialog.contract-popup .v-input--radio-group .v-messages {
    margin-bottom: 8px !important;
}

@media screen and (max-width: 920px) {
    .v-dialog.contract-popup.doble-contract {
        width: 95% !important;
    }    
    .v-dialog.contract-popup.doble-contract .v-card__actions{
        padding-left:20px;
        padding-right:20px;
    }
    .v-dialog.contract-popup.doble-contract .v-card__text .dialog-content {
        padding-left:20px !important;
        padding-right:20px !important;
    }
}

@media screen and (max-width: 600px) {
    .v-dialog.contract-popup  {
        width: 95% !important;
    }
    .v-dialog.contract-popup .v-card__actions {
        padding-left: 20px !important;
        padding-right: 20px !important;
    }
    .v-dialog.contract-popup .v-card__text .dialog-content {
        padding-left:0px !important;
        padding-right:0px !important;
    }
    .v-dialog.contract-popup.doble-contract .v-card__text .dialog-content {
        padding-left:0px !important;
        padding-right:0px !important;
    }
}

</style>

<style scoped>

.div-row {
    display: flex;
    width: 100%;
}

.modalV2 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5); 
    z-index: 1000; 
    opacity: 1;
}

.card{
    height: 600px;
    width: 1080px;
    background-color: white;
    border-radius: 10px;
    z-index: 1001; 
}

.row-card-title {
    width: 1080px;
    height: 70px;
    display:flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 24px 24px 24px 48px;
    border-bottom: 1px solid #e7e7e7;
    box-sizing: border-box;
}


.card-title {
    color: var(--v-primary-base);
    font-size: 20px;
    font-weight: 700;
}


.card-body {
    display: flex;
    height: 530px;
    width: 100%;
}

.item-service-and-plan{
    width: 549px
}

.card-body-left {
    height: 100%;
    width: 660px;   
    padding: 32px 48px 48px 48px;
    border-right: 1px solid #e7e7e7;
    overflow-y: auto;
    overflow-x: hidden;
}

.card-body-left .item-service {
    width: 100%;
    height: 32px;
    display: flex;
    padding-bottom: 20px;
    /* justify-content: space-between; */
    align-items: center;
}

.item-plan{
    width: 100%;
    display: flex;
    align-items: center;
    height: 40px;
    padding: 6px 12px 10px 6px;
}

.card-body-left .item-service .service-name {
    width: 30%;
    font-size: 18px;
    font-weight: 600;
    color: #454545;
}

.card-body-left .item-service .service-type {
    color: #454545;
    font-size: 14px;
    font-weight: 600;
    width: 205px;
}

.card-body-left .item-service .service-order{
    color: #565656;
    font-size: 14px;
    font-weight: 500;
}

.card-body-left .item-service .service-price{
    color: #6D6D6D;
    font-size: 14px;
    font-weight: 400;
}

.rotate-img{
    transform: rotate(180deg);
}

.card-body-right {
    height: 100%;
    width: 420px;   
    padding: 32px 46.5px 48px 46.5px;
    display:flex;
    flex-direction: column;
}

.div-total {
    width: 100%;
    height: 32px;
    display: flex;
    justify-content: right;
    align-items: center;
    border: 1px solid #262626;
    border-radius: 2px;
}

.button-siguiente {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 160px;
    border-radius: 8px;
    background-color: #7339B7;
    color: white
}

.button-siguiente.disabled {
    background-color: #B0B0B0;
}

.button-continue-payment {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 182px;
    border-radius: 8px;
    background-color: #7339B7;
    color: white
}

.button-continue-payment.disabled {
    background-color: #B0B0B0;
}

.defualt-text {
    font-size: 16px;
    font-weight: 500;
    color: #565656;
}

.date {
    font-size: 16px;
    font-weight: 500;
    color: var(--v-primaryDark-base);
}

span.title {
    color: var(--v-primary-base)
}

.plans {
    cursor: pointer;
    font-size: 0.80rem;
    background-color:white;
    &.selected {
        background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white);
    }
    &.disabled {
        opacity: 50%;
    }
    span {
        margin: auto;
    }
    border: 1px solid var(--v-primary-base);
}
button.btn-purple {
    color: #ffffff;
}

span.mark-time {
    font-size: 1rem;
    color: var(--v-primary-base);
}
span.mark-price {
    font-size: 1.2rem;
    color: var(--v-primary-base);
    font-weight: 500;
}

p.contract-date {
    color: var(--v-primary-base);
    font-weight: 500;
    font-size: 0.9rem;
    text-align: left;
}


.small-font {
    font-size: 0.80rem;
}
.promotional_code fieldset {
    color: white !important;
}

.contract-popup .total-price-title {
    font-size: 30px;
    font-weight: 500;
}
.contract-popup .total-price-title span {
    font-weight: 300;
    font-size: 20px;
}
.contract-popup .box-total-price {
    border-radius:4px;
    border:1px solid #565656;
    height: 32px;
    padding-top: 5px;
    padding-left:20px;
    padding-right:20px;
    font-weight: bold;
    font-size: 25px;
}
.contract-popup .box-total-price.filled {
    background-color: var(--v-neutralDark-base);
}

.shake {
    animation: shake 0.3s
}
.w-auto {
    width: auto !important;
}
.small-text-users-error {
    font-weight: 400;
    font-size: 12px;
    color: #565656;
}

.extra-users .plan-name{ border-bottom: 1px solid var(--primary-700); }
@keyframes shake {
    0% { transform: translateX(0) }
    25% { transform: translateX(-5px) }
    50% { transform: translateX(5px) }
    75% { transform: translateX(-5px) }
    100% { transform: translateX(0) }
}

</style>